/*
 * @Author: Merlin
 * @Date: 2024-03-21 15:02:52
 * @LastEditors: Merlin
 * @LastEditTime: 2024-03-25 10:30:06
 * @Description:  这些方法处理“弹出窗口” 的动画
 */

import * as oData from './pharaoh-anim-data';
import {u} from './pharaoh-anim-01';

class Mi {
    constructor(i, t, e) {
        this.atlas = i,
        this.atlasData = t,
        this.i = e,
        this.img = new u(i, t, "n9")
    }
    setType(i) {
        this.type !== i && (
            this.img.setType(i),
            this.type = i,
            this.setPos(this.x, this.y)
        )
    }
    setPos(i, t) {
        this.x = i,
        this.y = t,
        this.img.x = i - this.img.scW / 2,
        this.img.y = t - this.img.scH / 2,
        this.scW = this.img.x,
        this.scH = this.img.y
    }
    update() {}
    redraw(i) {
        this.img.alpha !== void 0 
        ? (
            i.save(),
            i.globalAlpha = this.img.alpha,
            this.img.redraw(i),
            i.restore()
        )
        : this.img.redraw(i)
    }
}


let Y = null;
class Li {
    constructor(i, t, e, s) {
        this.atlas = i,
        this.atlasData = t,
        this.i = e;
        const o = 175, a = 209.5, r = 30;
        this.x = o + a * e + r * e,
        this.y = 208,
        this.cells = [];
        for (let h = 0; h < 2; h++) {
            const l = new Mi(i, t, h);
            l.setPos(this.x, h ? this.y - 184 : this.y),
            this.cells.push(l)
        }
        this.cells[0].nextCell = this.cells[1],
        this.cells[1].nextCell = this.cells[0],
        Y = this.cells[0].y - this.cells[1].y,
        this.cells[0].setType("bonusPharaon"),
        this.cells[1].setType("n9Bluer"),
        this.updateCellAnimation = s
    }
    startMove(i=2, t) {
        this.currNum = 9,
        this.endResult = t,
        this.speed = Y / 3,
        this.backSpeed = this.speed / 2.6,
        this.i === 0 && (this.backSpeed = this.speed / 2.8),
        this.startBackSped = this.backSpeed,
        this.isMove = !0,
        this.counter = i
    }
    update() {
        const check01 = (
            this.cells.forEach(t=>t.update()),
            this.isMove
        );
        if (!check01) return;
        if (
            this.cells.forEach(t=>t.setPos(t.x, t.y + this.speed)),
            this.counter > 0
        ){
            this.cells.forEach((t, e)=>{
                const check01 = t.y > 394 && this.backSpeed === this.startBackSped;
                if (!check01) return;
                this.currNum--,
                this.currNum < 0 && (this.currNum = 9),
                t.setPos(t.x, t.nextCell.y - Y),
                t.setType(`n${this.currNum}Bluer`);
                if (
                    this.currNum === this.endResult - 1 || this.endResult === 0 && this.currNum === 9
                ){
                    this.counter--;
                    if (this.counter === 0){
                        this.i === 2
                        ? (
                            this.sounds.bonus_game_vild_1.stop(),
                            this.sounds.bonus_game_vild_1.toPlay()
                        ) : 
                        this.i === 1 && (
                            this.sounds.bonus_game_vild_2.stop(),
                            this.sounds.bonus_game_vild_2.toPlay()
                        );
                        e === 0
                        ? (
                            this.cells[0].upY = this.y - 184,
                            this.cells[1].upY = this.y
                        ) : (
                            this.cells[0].upY = this.y,
                            this.cells[1].upY = this.y - 184
                        );
                        this.cells[0].setType(this.cells[0].type.split("Bluer")[0]);
                        this.cells[1].setType(this.cells[1].type.split("Bluer")[0]);
                    }
                }
            });
        } else {
            this.speed -= this.backSpeed,
            this.backSpeed *= .8,
            this.speed < -7 && this.i === 0 && (this.speed = -7);

            this.cells.forEach(e=>{
                e.y < e.upY && e.setPos(e.x, e.upY)
            });
            let t = !0;
            this.cells.forEach(e=>{
                e.y !== e.upY && (t = !1)
            });
            t && (
                this.i === 0
                ? this.isMove = !this.updateCellAnimation()
                : this.isMove = !1, this.isMove || this.onEnd()
            );
        }
    }
    redraw(i) {
        this.cells.forEach(t=>t.redraw(i)),
        i.clearRect(this.x - 222 / 2, -68, 222, 184),
        i.clearRect(this.x - 222 / 2, 298, 222, 184)
    }
}



const K = Math.PI * 2;
class Di {
    constructor() {}
    init(i, t) {
        const e = (o, a)=>Math.random() * (a - o) + o;
        this.x = i + e(0, 80);
        this.y = t + e(0, 90);
        this.radius = e(3, 7);
        this.scale = e(.7, 1);
        this.speedX = e(-5, 5);
        this.speedY = e(-5, 5);
        const s = Math.floor(-20, 20);
        this.color = `255, ${216 + s}, ${21 + s}`;
    }
    update() {
        this.x += this.speedX * this.scale,
        this.y += this.speedY * this.scale,
        this.scale > 0 ? this.scale -= .035 : this.scale = 0
    }
    redraw(i) {
        if (this.scale > 0) {
            const t = this.radius * this.scale;
            i.fillStyle = `rgba(${this.color}, 0.3)`,
            i.beginPath(),
            i.arc(this.x, this.y, t * 1.5, 0, K),
            i.fill(),
            i.fillStyle = `rgb(${this.color})`,
            i.beginPath(),
            i.arc(this.x, this.y, t, 0, K),
            i.fill()
        }
    }
}


// ↓ 主要类 -------------------------------------------
export class ki {
    constructor() {
        this.live = !0,
        this.parts = []
    }
    updateCellAnimation() {
        this.hideLightAnimation();
        const {x_p: i, y_p: t, a: e, sc: s} = oData.O[this.cellFrame];
        this.lines.forEach(o=>{
            o.cells.forEach(a=>{
                a.img.setScale(s);
                a.img.x = a.x + i;
                a.img.y = a.y + t;
                a.img.alpha !== 0 && (a.img.alpha = e);
            });
        });
        if ( this.cellFrame === 2 ){
            this.lines.forEach(o=>{
                o.cells.forEach(a=>{
                    a.type.length === 2 && a.setType(a.type.replace("n", "nw"))
                })
            });
        } else if (this.cellFrame === 10) {
            const o = this.res[0] === "0";
            const a = o && this.res[1] === "0" && this.res[2] !== "0";
            [o, a, !1].forEach((r, h)=>{
                this.lines[h].cells.forEach(l=>{
                    l.img.alpha = r ? 0 : 1;
                    for (let f = 0; f < 20; f++) {
                        this.getPart().init(l.img.x, l.img.y)
                    }
                })
            })
        }
        return this.cellFrame++,
        this.cellFrame === 1 && (
            this.sounds.bonus_game_vild_3.stop(),
            this.sounds.bonus_game_vild_3.toPlay()
        ),
        this.cellFrame === this.cellMaxFrame
    }
    // ↓ init ====================================================
    init(i, t) {
        this.parts.forEach(s=>s.scale = 0);
        this.cellFrame = 0;
        this.cellMaxFrame = oData.O.length;
        this.sounds = t;
        this.canvas = i;
        this.ctx = i.getContext("2d");
        this.ctx.globalCompositeOperation = "destination-over";
        this.live = !0;
        this.lines = [];
        const {atlas: e} = this;
        for (let s = 0; s < 3; s++) {
            const o = new Li(e, oData.p, s, ()=>this.updateCellAnimation());
            o.sounds = t;
            this.lines[s] = o
        }
        this.bg = new u(e, oData.p, "gBg");
        this.bg.x = 2.5;
        this.bg.y = 109.5;
        this.imgLight = new u(e, oData.p, "blueLight");
        this.imgLight.x = 42;
        this.imgLight.y = 85;
        this.showLight = !1;
        this.imgLight.alpha = 0
    }
    getPart() {
        let i = this.parts.find(t=>t.scale <= 0);
        return i = new Di,
        this.parts.push(i),
        i
    }
    showAnim({res: i, endSpin2: t, endSpin1: e, endSpin0: s, onEndAnimation: o}) {
        this.res = i;
        this.lines.forEach((a, r)=>{
            a.startMove(r === 0 ? 5 : 4 - r, Number(i.split("")[r]))
        });
        this.lines[0].cells.forEach(a=>a.img.alpha = 1),
        this.lines[2].onEnd = t,
        this.lines[1].onEnd = e,
        this.lines[0].onEnd = s,
        this.onEndAnimation = o
    }
    showLightAnimation() {
        this.showLight = !0
    }
    hideLightAnimation() {
        this.showLight = !1
    }
    update() {
        (this.parts || []).forEach(i=>i.update());
        (this.lines || []).forEach(i=>i.update());
        this.showLight
        ? this.imgLight.alpha += .02
        : (
            this.imgLight.alpha -= .05,
            this.imgLight.alpha < 0 && (
                this.imgLight.alpha = 0,
                this.lines[0].isMove || this.onEndAnimation()
            )
        )
    }
    redraw() {
        this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
        this.animation && this.parts.forEach(i=>{
            i.redraw(this.ctx)
        });
        this.lines.forEach(i=>{
            i.redraw(this.ctx)
        });
        this.ctx.save(),
        this.ctx.globalAlpha = this.imgLight.alpha,
        this.animation && this.imgLight.redraw(this.ctx),
        this.ctx.restore(),
        this.bg.redraw(this.ctx)
    }
}
